import { object, array, number, string, boolean } from '@gogame/schemas';

import {
  IDS,
  NETWORKS,
  CHANNELS,
  EXCLUSIVE_FOR_AFFILIATES,
  LANGUAGE,
  ENHANCERS,
  AI_GENERATED,
  TAGS,
  JIRA_TASK,
  TESTED,
  REQUESTED_BY,
  POSTFIX,
  OUTSOURCE_STUDIO_ID,
  DESIGNER,
  DESCRIPTION,
  PRODUCTION_TYPE,
} from './constants';

export const validationSchema = object({
  [IDS]: array(number()),
  [NETWORKS]: array(number()).nullable().default(null),
  [CHANNELS]: array(number()).nullable().default(null),
  [EXCLUSIVE_FOR_AFFILIATES]: array(number()).nullable().default(null),
  [LANGUAGE]: number().nullable().default(null),
  [PRODUCTION_TYPE]: number().nullable().default(null),
  [ENHANCERS]: array(number()).nullable().default(null),
  [AI_GENERATED]: boolean().default(false),
  [TAGS]: array(number()).nullable().default(null),
  [JIRA_TASK]: string().nullable().default(null),
  [TESTED]: number().nullable().default(null),
  [REQUESTED_BY]: number().nullable().default(null),
  [POSTFIX]: string().nullable().default(null),
  [OUTSOURCE_STUDIO_ID]: number().nullable().default(null),
  [DESIGNER]: number().nullable().default(null),
  [DESCRIPTION]: string().nullable().default(null),
});
